var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[_c('div',{staticClass:"menu"},[(_vm.isExpanded)?_c('ul',{class:_vm.cssClasses,attrs:{"id":_vm.id}},[_vm._t("default")],2):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }